import type { ColumnType, Selectable, Insertable, Updateable } from "kysely";
import { z } from "zod";

/** Identifier type for verifications */
export type VerificationsId = string & { __flavor: "VerificationsId" };

/**
 * Represents the table public.verifications
 * @uniqueConstraints {"verifications_pkey":{"name":"verifications_pkey","isPrimary":true,"isUnique":true,"columns":[{"name":"id","definition":"id","predicate":null}]},"verifications_identifier_index":{"name":"verifications_identifier_index","isPrimary":false,"isUnique":false,"columns":[{"name":"identifier","definition":"identifier","predicate":null}]}}
 */
export default interface VerificationsTable {
  id: ColumnType<VerificationsId, VerificationsId, VerificationsId>;

  identifier: ColumnType<string, string, string>;

  value: ColumnType<string, string, string>;

  expiresAt: ColumnType<Date, Date | string, Date | string>;

  createdAt: ColumnType<Date, Date | string | undefined, Date | string>;

  updatedAt: ColumnType<Date, Date | string | undefined, Date | string>;
}

export type Verifications = Selectable<VerificationsTable>;

export type NewVerifications = Insertable<VerificationsTable>;

export type VerificationsUpdate = Updateable<VerificationsTable>;

export const verificationsId = z.string() as unknown as z.Schema<VerificationsId>;

export const verifications = z.object({
  id: verificationsId,
  identifier: z.string(),
  value: z.string(),
  expiresAt: z.date(),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export const verificationsInitializer = z.object({
  id: verificationsId,
  identifier: z.string(),
  value: z.string(),
  expiresAt: z.date(),
  createdAt: z.date().optional(),
  updatedAt: z.date().optional(),
});

export const verificationsMutator = z.object({
  id: verificationsId.optional(),
  identifier: z.string().optional(),
  value: z.string().optional(),
  expiresAt: z.date().optional(),
  createdAt: z.date().optional(),
  updatedAt: z.date().optional(),
});

// ── constraints for Verifications ─────────────────────────────────
export const VerificationsConstraints = {
  verifications_pkey: {
    name: "verifications_pkey",
    isPrimary: true,
    isUnique: true,
    columns: [{ name: "id", definition: "id", predicate: null }],
  },
  verifications_identifier_index: {
    name: "verifications_identifier_index",
    isPrimary: false,
    isUnique: false,
    columns: [{ name: "identifier", definition: "identifier", predicate: null }],
  },
} as const;
export type VerificationsConstraintsType = typeof VerificationsConstraints;
